import { forwardRef } from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import type {
  TPopoverAnchorElement,
  TPopoverAnchorProps,
} from "@/ui/components/overlay/Popover/Popover.config";

export const PopoverAnchor = forwardRef<TPopoverAnchorElement, TPopoverAnchorProps>(
  (props, ref) => (
    <PopoverPrimitive.Anchor
      ref={ref}
      data-component="PopoverAnchor"
      {...props}
    />
  ),
);

PopoverAnchor.displayName = PopoverPrimitive.Anchor.displayName;
